module.exports = __webpack_public_path__ + "img/curve_2.f9eda4a0.png";